export default __webpack_public_path__ + "static/media/road_img_3_2.723e1376.jpg";